<template>
	<div class="footer">
		<helio-button-group
			:segmented="false"
			alignment="right"
		>
			<slot />
		</helio-button-group>
	</div>
</template>

<script>
import ButtonGroup from '../../button-group/ButtonGroup.vue';

export default {
	components: {
		'helio-button-group': ButtonGroup,
	},
};
</script>

<style lang="scss" scoped src="./footer.scss" />
